import createStore from 'unistore';

const Store = createStore({
  householdSize: 123,
  householdMembers: 3,

  isRel: true,
  isLoading: true,
  distributionData: false,
  compareData: false,
  additionalData: false,
  infoboxContent: false,
  overallKey: 'Gesamtbevölkerung',
  compareKey: 'Erwerbsstatus.Rentner',
  tooltipKey: 'Gesamtbevölkerung',
  householdIncome: 2920,
  householdMembersAbove14: 2,
  householdMembersBelow14: 0,
  tooltipX: 0,
  tooltipY: 0,
  tooltipVisible: false,
});

export default Store;
